import { IFacility } from '@/types';
import React from 'react';

function mapErrorMessage(item: IFacility) {
  if (item?.error_message) {
    return item?.error_message + '. ';
  }
  return 'This facility is sold out for this period.';
}

type ButtonStatusProps = {
  status: string;
  facility_url_code: string;
  hoverIndex?: number;
  currentIndex?: number;
  minDays?: number;
  maxDays?: number;
  configInfo?: {};
  checkin?: string;
  checkout?: string;
  isCardList?: boolean;
  isNewCardList?: boolean;
  errorMessage?: any;
  item?: IFacility;
};

function ButtonStatus({
  status,
  minDays,
  maxDays,
  isCardList,
  isNewCardList,
  item,
}: ButtonStatusProps) {
  function handleErrorMessage(status) {
    switch (status) {
      case 'unavailable':
        return (
          <>
            {minDays > 0 && maxDays > 0 && (
              <small className="text-xs">
                This facility requires a minimun of <strong>{minDays}</strong>{' '}
                and max of <strong>{maxDays}</strong> days.{' '}
                {/* <span
                  className="text-[#03A1CF] underline cursor-pointer pointer-events-auto"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                  }
                >
                  Change the dates!
                </span> */}
              </small>
            )}
            {maxDays === 0 && minDays > 0 && (
              <small className="text-xs">
                This facility requires a minimum of <strong>{minDays}</strong>{' '}
                days.{' '}
                {/* <span
                  className="text-[#03A1CF] underline cursor-pointer pointer-events-auto"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                  }
                >
                  Change the dates!
                </span> */}
              </small>
            )}
            {minDays === 0 && maxDays > 0 && (
              <small className="text-xs">
                This facility requires a max of <strong>{maxDays}</strong> days.
                {/* <span
                  className="text-[#03A1CF] underline cursor-pointer pointer-events-auto"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                  }
                >
                  Change the dates!
                </span> */}
              </small>
            )}
          </>
        );
      case 'soldout':
        return (
          <small className="text-xs">
            {mapErrorMessage(item)}{' '}
            {/* <span
              className="text-[#03A1CF] underline cursor-pointer pointer-events-auto"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              Change the dates!
            </span> */}
          </small>
        );
    }
  }

  return status === 'unavailable' || status === 'soldout' ? (
    <>
      <div
        className={`flex justify-between items-center w-full gap-x-2 md:gap-x-4 ${isNewCardList ? 'flex-row lg:flex-col' : 'flex-row'
          }`}
      >
        <p className={isNewCardList ? 'lg:order-2' : ''}>
          {handleErrorMessage(status)}
        </p>
        <p
          className={`font-bold text-red-700 whitespace-nowrap ${isNewCardList ? 'lg:order-1' : ''}`}
        >
          {isNewCardList || isCardList || status === 'soldout' ? 'Sold Out' : 'Unavailable'}
        </p>
      </div>
    </>
  ) : (
    <></>
  );
}

export default ButtonStatus;
